<template>
    <div class="net-error-page">
        <div class="notice">
            <p class="head">404</p>
            <p class="error">ERROR</p>
        </div>
        <div class="info">{{ $t('com.sorry_page_not_found') }}</div><!--对不起，您访问的页面不存在...-->
        <div class="operate">
            <router-link :to="{path: '/home'}" class="home">{{ $t('com.back')+$t('com.home') }}</router-link><a 
            @click="back()" class="back">{{ $t('com.return_prev_page') }}</a> <!--返回首页  返回上一页-->
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
export default {
    data() {
      return {

      }
    },
    methods: {
        back() {
            this.$router.go(-1)
        }
    }
}
</script>

<style scoped lang="scss">
@import './net-error.scss'
</style>



// WEBPACK FOOTER //
// src/page/net-error.vue